/* eslint-disable */
export default {
  order: 5,
  header: [],
  content: [
    {
      category: '2.3 发布记录 (2021/12/30)  ',
      description: '查看 EnOS 版本信息。',
      image: '',
      url: '',
      isVersionInfo: true,
      item: [
        {
          name: 'EnOS™ Cloud 2.3 Cumulative Update',
          description: 'Cumulative Update （CU）是每个季度内新功能、优化与错误修复的集合。',
          image: '',
          list: [
            {
              name: '2.3 CU 5',
              url: '/docs/enos/zh_CN/2.3.0/releasenotes/cu5.html'
            },
            {
              name: '2.3 CU 4',
              url: '/docs/enos/zh_CN/2.3.0/releasenotes/cu4.html'
            },
            {
              name: '2.3 CU 3',
              url: '/docs/enos/zh_CN/2.3.0/releasenotes/cu3.html'
            },
            {
              name: '2.3 CU 2',
              url: '/docs/enos/zh_CN/2.3.0/releasenotes/cu2.html'
            },
            {
              name: '2.3 CU 1',
              url: '/docs/enos/zh_CN/2.3.0/releasenotes/cu1.html'
            }
          ]
        },
        {
          name: 'EnOS™ Cloud 2.3',
          description: '',
          image: '',
          list: [
            {
              name: '新增功能与功能改进',
              url: '/docs/enos/zh_CN/2.3.0/releasenotes/new_feature.html'
            },
            {
              name: '行为变更',
              url: '/docs/enos/zh_CN/2.3.0/releasenotes/enhancement.html'
            },
            {
              name: '弃用/移除功能',
              url: '/docs/enos/zh_CN/2.3.0/releasenotes/deprecated.html'
            },
            {
              name: '已知问题',
              url: '/docs/enos/zh_CN/2.3.0/releasenotes/knownissue.html'
            }
          ]
        },
        {
          name: 'EnOS™ Edge 2.3',
          description: '',
          image: '',
          list: [
            {
              name: '新增功能与功能改进',
              url: '/docs/enos-edge/zh_CN/2.3.0/releasenotes/new_feature.html'
            },
            {
              name: '行为变更',
              url: '/docs/enos-edge/zh_CN/2.3.0/releasenotes/enhanced_feature.html'
            }
          ]
        }
      ]
    },
    {
      category: 'EnOS™ 基础及核心服务',
      description: 'EnOS，全球领先的智能物联网操作系统，致力于推动企业和城市数字化转型，实现生态发展。',
      image: '',
      url: '/docs/enos/zh_CN/2.3.0/overview/enos_introduction.html',
      item: [
        {
          name: '入门信息',
          description: '了解 EnOS 的产品优势、关键概念，快速开始使用 EnOS。',
          image: '',
          list: [
            {
              name: '什么是 EnOS',
              url: '/docs/enos/zh_CN/2.3.0/overview/enos_introduction.html'
            },
            {
              name: 'EnOS 入门指引',
              url: '/docs/enos/zh_CN/2.3.0/getting_started_with_enos/getting_started_with_enos.html'
            },
            {
              name: '常见问题',
              url: '/docs/enos/zh_CN/2.3.0/faq/index.html'
            }
          ]
        },
        {
          name: 'EnOS™ 管理门户',
          description: '为物联网实施人员、数据科学家和应用开发者等提供统一的基于 GUI 操作界面，一站式管理物联网连接、数据、分析、应用的全生命周期，带来流畅一致的体验。',
          image: '',
          list: [
            {
              name: '访问 EnOS',
              url: '/docs/enos/zh_CN/2.3.0/overview/accessing_enos.html'
            },
            {
              name: '关于 EnOS 管理控制台',
              url: '/docs/enos/zh_CN/2.3.0/overview/enos_console_overview.html'
            },
            {
              name: 'EnOS 管理门户 GUI 使用惯例',
              url: '/docs/enos/zh_CN/2.3.0/overview/ui_conventions.html'
            }
          ]
        },
        {
          name: '身份与授权',
          description: '提供用户帐号生命周期管理，支持对EnOS资源的访问权限控制，实现对用户身份与权限的集中化、灵活化管理，有效保护企业信息安全。',
          image: '',
          list: [
            {
              name: '有关身份与授权',
              url: '/docs/enos/zh_CN/2.3.0/iam/iam_overview.html'
            },
            {
              name: '概念',
              url: '/docs/enos/zh_CN/2.3.0/iam/concept/index.html'
            },
            {
              name: 'LDAP联合',
              url: '/docs/enos/zh_CN/2.3.0/iam/ou_admin/ldap/index.html'
            }
          ]
        },
        {
          name: '资源管理',
          description: '支持对资源使用的灵活管理，可对资源利用进行告警设置，提高企业资源透明度与资源利用率，减少资源成本浪费。',
          image: '',
          list: [
            {
              name: 'EnOS 上的资源',
              url: '/docs/enos/zh_CN/2.3.0/resourcemanagement/overview.html'
            },
            {
              name: '资源规格说明',
              url: '/docs/enos/zh_CN/2.3.0/resourcemanagement/reference/index.html'
            },
            {
              name: '快速申请资源',
              url: '/docs/enos/zh_CN/2.3.0/resourcemanagement/getstarted.html'
            }
          ]
        },
        {
          name: '计量',
          description: '多维度展示接入平台资源和服务使用的计量数据, 平台运营人员可通过各项计量统计数据评估平台运营情况，为运营策略调整提供数据支撑。',
          image: '',
          list: [
            {
              name: '关于计量服务',
              url: '/docs/enos/zh_CN/2.3.0/metering/metering_overview.html'
            }
          ]
        },
        {
          name: '审计服务',
          description: '支持对用户的登录登出和各项操作行为进行监控和审计，操作历史事件在保存期内可保证所有记录的不可篡改性和可追溯性，满足企业客户的安全合规要求。',
          image: '',
          list: [
            {
              name: '操作审计',
              url: '/docs/enos/zh_CN/2.3.0/audit/audit_overview.html'
            }
          ]
        },
        {
          name: '应用注册',
          description: '支持应用开发者快速进行应用的注册、购买、编辑、导出等，实现便捷的应用管理。',
          image: '',
          list: [
            {
              name: '注册和管理应用',
              url: '/docs/app-development/zh_CN/2.3.0/app_management/managing_apps.html'
            }
          ]
        },
        {
          name: 'EnOS™ API',
          description: '提供涵盖 EnOS 各个核心业务流程的 API 接口和 API 文档，帮助快速访问系统资源，加速应用开发。',
          image: '',
          list: [
            {
              name: '有关 EnOS API',
              url: '/docs/api/zh_CN/2.3.0/overview.html'
            },
            {
              name: 'API 鉴权',
              url: '/docs/api/zh_CN/2.3.0/authen_overview.html'
            },
            {
              name: 'EnOS API 快速入门',
              url: '/docs/api/zh_CN/2.3.0/gettingstarted.html'
            },
            {
              name: 'API 参考文档',
              url: '/docs/api/zh_CN/2.3.0/api_reference.html'
            }
          ]
        },
        {
          name: '安全',
          description: '了解EnOS中内置的安全技术。',
          image: '',
          list: [
            {
              name: '安全概览',
              url: '/docs/enos/zh_CN/2.3.0/security/security_overview.html'
            },
            {
              name: 'X.509 证书服务',
              url: '/docs/enos/zh_CN/2.3.0/security/x509_ca/index.html'
            },
            {
              name: '身份与权限管理',
              url: '/docs/enos/zh_CN/2.3.0/iam/iam_overview.html'
            }
          ]
        },
        {
          name: '数据源注册',
          description: '支持 EnOS 内外部数据源统一注册及管理，以供相关产品模块直接访问数据源信息。',
          image: '',
          list: [
            {
              name: '数据源注册概述',
              url: '/docs/data-source-reg/zh_CN/2.3.0/datasource_overview.html'
            },
            {
              name: '注册各类数据源',
              url: '/docs/data-source-reg/zh_CN/2.3.0/index.html'
            }
          ]
        }
      ]
    },

    {
      category: 'EnOS™ Edge',
      description: 'EnOS™ Edge 基于 EnOS™ 软件系统且支持各类硬件，提供高效的物联接入、边缘计算、本地控制与优化等解决方案，快速适配物理世界的多种异构设备与系统。',
      image: 'assets/images/EnOS Edge_LIght.png',
      url: '/docs/enos-edge/zh_CN/2.3.0/edge_overview.html',
      item: [
        {
          name: 'EnOS™ Edge 用户指南',
          description: 'EnOS Edge 通过内置协议库适配并加速设备连接，提供边缘计算和本地控制，帮助用户及时决策和响应，将云端智能扩展至边缘。',
          image: 'assets/images/edge/user.png',
          list: [
            {
              name: '产品简介',
              url: '/docs/enos-edge/zh_CN/2.3.0/edge_overview.html'
            },
            {
              name: 'Edge 设备接入教程',
              url: '/docs/enos-edge/zh_CN/2.3.0/tutorial/connecting_edge.html'
            },
            {
              name: 'API 文档',
              url: '/docs/edge-api/zh_CN/2.3.0/index.html'
            }
          ]
        }
      ]
    },

    {
      category: 'IoT Hub',
      description: '广泛、安全和快速的连接到多源异构的传感器、设备及系统，提供设备的全生命周期管理。',
      image: 'assets/images/IoT Hub_LIght.png',
      url: '/docs/dcm/zh_CN/2.3.0/iot_hub_overview.html',
      item: [
        {
          name: '设备连接与管理服务',
          description: '支持海量异构设备或系统的实时和历史数据的快速接入和管理；内置数字孪生模型库，快速实现行业领域设备的数字化抽象；提供设备的全生命周期管理和动态告警触发，实现设备异常及故障的快速响应。',
          image: 'assets/images/iothub/Connectivity.png',
          list: [
            {
              name: '设备连接概述',
              url: '/docs/device-connection/zh_CN/2.3.0/device_management_overview.html'
            },
            {
              name: '模型管理',
              url: '/docs/device-connection/zh_CN/2.3.0/howto/model/index.html'
            },
            {
              name: '告警管理',
              url: '/docs/alert/zh_CN/2.3.0/learn/alert_overview.html'
            },
            {
              name: '设备连接快速入门',
              url: '/docs/device-connection/zh_CN/2.3.0/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: 'API 文档',
              url: '/docs/device-connection/zh_CN/2.3.0/reference/api_reference'
            }
          ]
        },
        {
          name: '设备集成服务',
          description: '通过拖拉拽体验的低代码任务流方式加速企业设备数据集成, 并提供运行状态监控与告警服务，降低运维成本。',
          image: 'assets/images/iothub/Integration.png',
          list: [
            {
              name: '设备集成概述',
              url: '/docs/device-integration/zh_CN/2.3.0/learn/device_integration_overview.html'
            },
            {
              name: '设备集成快速入门',
              url: '/docs/device-integration/zh_CN/2.3.0/howto/gettingstarted_storing_data'
            },
            {
              name: 'Node 参考',
              url: '/docs/device-integration/zh_CN/2.3.0/reference/index_nodes.html'
            }
          ]
        }
      ]
    },

    {
      category: '企业数据平台',
      image: 'assets/images/Enterprise Data Platform_LIght.png',
      description: '挖掘数据资产价值，降低海量物联网数据的TCO，帮助你实现对设备资产数据的高效管理。',
      url: '/docs/data-asset/zh_CN/2.3.0/data_asset_overview.html',
      item: [
        {
          name: '数据资产目录',
          description: '助力海量多源数据的统一管理并落地数据模型和数据规范，实现对数据的高效查询，挖掘数据价值，帮助企业用户快速理解企业数据资产。',
          image: 'assets/images/edp/Data_Asset_Catalog.png',
          list: [
            {
              name: '数据资产目录概述',
              url: '/docs/data-asset-catalog/zh_CN/2.3.0/data_catalog_intro.html'
            },
            {
              name: '快速入门',
              url: '/docs/data-asset-catalog/zh_CN/2.3.0/data_catalog_quickstart.html'
            },
            {
              name: '同步数据资产',
              url: '/docs/data-asset-catalog/zh_CN/2.3.0/howto/data_sync.html'
            },
            {
              name: '管理数据对象',
              url: '/docs/data-asset-catalog/zh_CN/2.3.0/howto/data_management.html'
            }
          ]
        },
        {
          name: '流数据处理',
          description: '沉淀典型计算场景的通用算子及模板，支持数据开发者拖拽式无代码快速开发流数据处理与分析的任务流。',
          image: 'assets/images/edp/Stream_Processing.png',
          list: [
            {
              name: '流数据处理概述',
              url: '/docs/stream-processing/zh_CN/2.3.0/streaming_overview.html'
            },
            {
              name: '开发流数据处理任务',
              url: '/docs/stream-processing/zh_CN/2.3.0/dev.html'
            },
            {
              name: '运维流数据处理任务',
              url: '/docs/stream-processing/zh_CN/2.3.0/ops.html'
            },
            {
              name: 'API 文档',
              url: '/docs/stream-processing-api/zh_CN/2.3.0/overview.html'
            }
          ]
        },
        {
          name: '时序数据管理',
          description: '为海量物联网时序数据提供高吞吐、高可用、高压缩比的存储，并配套提供高效查询API及可视化工具，实现对时序数据的快速洞察。',
          image: 'assets/images/edp/Time_Series_Data_Management.png',
          list: [
            {
              name: '时序数据管理概述',
              url: '/docs/time-series-data/zh_CN/2.3.0/overview.html'
            },
            {
              name: '快速入门',
              url: '/docs/time-series-data/zh_CN/2.3.0/getting_started.html'
            },
            {
              name: '存储策略（EnOS Cloud 用户）',
              url: '/docs/time-series-data/zh_CN/2.3.0/cloudpolicy/policy.html'
            },
            {
              name: '存储策略（EnOS Edge 用户）',
              url: '/docs/time-series-data/zh_CN/2.3.0/edgepolicy/policy.html'
            },
            {
              name: 'API 文档',
              url: '/docs/time-series-data/zh_CN/2.3.0/reference/api.html'
            }
          ]
        },
        {
          name: '数据联邦',
          description: '在不移动或同步数据的情况下，为企业的多源异构数据存储系统建立统一的数据读写服务，赋能不同的数据使用方能够通过标准 SQL、JDBC、或 OData 等统一查询方式高效访问数据。',
          image: 'assets/images/edp/Data_Federation.png',
          list: [
            {
              name: '数据联邦概述',
              url: '/docs/data-federation/zh_CN/2.3.0/data_federation_overview.html'
            },
            {
              name: '管理数据联邦通道',
              url: '/docs/data-federation/zh_CN/2.3.0/channel_management.html'
            },
            {
              name: '读写数据',
              url: '/docs/data-federation/zh_CN/2.3.0/data_rw.html'
            },
            {
              name: 'API 文档',
              url: '/docs/data-federation-api/zh_CN/2.3.0/overview.html'
            }
          ]
        },
        {
          name: '数据订阅',
          description: '数据订阅服务支持将订阅的数据实时推送给消费数据的应用，提高应用获取和消费资产数据的效率。基于数据订阅服务提供的 SDK，应用可高效地进行数据订阅。',
          image: 'assets/images/edp/Data_Subscription.png',
          list: [
            {
              name: '数据订阅概述​',
              url: '/docs/data-subscription/zh_CN/2.3.0/data_subscription_overview.html'
            },
            {
              name: '数据订阅快速入门',
              url: '/docs/data-subscription/zh_CN/2.3.0/gettingstarted_subscribe_realtime.html'
            },
            {
              name: '消费订阅数据（EnOS Cloud 用户）',
              url: '/docs/data-subscription/zh_CN/2.3.0/consuming_subscribed_data.html'
            },
            {
              name: '消费订阅数据（EnOS Edge 用户）',
              url: '/docs/data-subscription/zh_CN/2.3.0/consuming_subscribed_data_edge.html'
            },
            {
              name: '数据订阅 SDK 参考',
              url: '/docs/data-subscription/zh_CN/2.3.0/data_subscription_sdk.html'
            }
          ]
        },
        {
          name: '数据归档',
          description: '通过周期性归档任务实现大规模数据备份，对访问频率较低且占用存储空间大的“冷数据”进行经济化存储。',
          image: 'assets/images/edp/Data_Archiving.png',
          list: [
            {
              name: '数据归档概述',
              url: '/docs/data-archiving/zh_CN/2.3.0/archive_policy.html'
            },
            {
              name: '配置数据归档任务',
              url: '/docs/data-archiving/zh_CN/2.3.0/configuring_archive_storage.html'
            },
            {
              name: '数据归档逻辑说明',
              url: '/docs/data-archiving/zh_CN/2.3.0/archive_storage.html'
            }
          ]
        },
        {
          name: '数据同步',
          description: '打通外部存储系统与 EnOS 内部存储系统之间的数据传输通道，帮助实现集中式数据同步和共享。',
          image: 'assets/images/edp/Data_Synchronization.png',
          list: [
            {
              name: '数据同步概述',
              url: '/docs/data-sync/zh_CN/2.3.0/di_overview.html'
            },
            {
              name: '从外部数据库同步数据到EnOS Hive',
              url: '/docs/data-sync/zh_CN/2.3.0/creating_scratch_onetime.html'
            },
            {
              name: '从 EnOS Hive 同步数据到目的数据库',
              url: '/docs/data-sync/zh_CN/2.3.0/creating_scratch_hive2mysql.html'
            }
          ]
        },
        {
          name: '批数据处理',
          description: '帮助数据开发者通过可视化任务流的方式进行大规模数据处理，提供稳定的调度服务，并可基于数据湖、数据仓库及用户侧应用，对相关数据进行计算、分析、洞察等。',
          image: 'assets/images/edp/Batch_Processing.png',
          list: [
            {
              name: '批数据处理概述​',
              url: '/docs/batch-processing/zh_CN/2.3.0/dataide_overview.html'
            },
            {
              name: '任务资源管理',
              url: '/docs/batch-processing/zh_CN/2.3.0/job_resource/index.html'
            },
            {
              name: '任务流开发',
              url: '/docs/batch-processing/zh_CN/2.3.0/data_dev/index.html'
            },
            {
              name: '任务流运维',
              url: '/docs/batch-processing/zh_CN/2.3.0/task_monitor/index.html'
            }
          ]
        },
        {
          name: '数据资产权限（预览）',
          description: '对组织数据资产访问权限进行集中式管理，提升数据平台系统安全性。',
          image: '',
          list: [
            {
              name: '数据资产权限概述​',
              url: '/docs/data-asset-auth/zh_CN/2.3.0/data_asset_permission.html'
            },
            {
              name: '管理数据资产权限策略',
              url: '/docs/data-asset-auth/zh_CN/2.3.0/managing_permission_policy.html'
            }
          ]
        },
        {
          name: '指标管理（预览）',
          description: '构建统一指标体系，建立数据标准，实现指标数据全生命周期管理。',
          image: '',
          list: [
            {
              name: '指标管理概述​',
              url: '/docs/metric-management/zh_CN/preview/overview/metrics_overview.html'
            },
            {
              name: '关键概念',
              url: '/docs/metric-management/zh_CN/preview/overview/metrics_concept.html'
            }
          ]
        }
      ]
    },

    {
      category: '企业分析平台',
      image: 'assets/images/Enterprise Analytics Platform_LIght.png',
      description: '在企业数据平台和数据湖的基础上，整合多系统中的数据合力，解锁业务洞察。',
      url: '/docs/ai-analytics/zh_CN/2.3.0/ai_analytics_overview.html',
      item: [
        {
          name: '数据集管理',
          description: '通过创建可用于算法开发和模型训练的数据集，帮助数据科学家在训练模型时快速访问数据，而不用关心如何连接数据源、以及不同数据源的连接串和数据访问路径的差异，提升工作效率。',
          image: 'assets/images/eap/Dataset_Management.png',
          list: [
            {
              name: '数据集管理概述',
              url: '/docs/ai-analytics/zh_CN/2.3.0/dataset_management/dataset_overview.html'
            },
            {
              name: '创建数据集',
              url: '/docs/ai-analytics/zh_CN/2.3.0/dataset_management/creating_dataset.html'
            },
            {
              name: '管理数据集',
              url: '/docs/ai-analytics/zh_CN/2.3.0/dataset_management/managing_dataset.html'
            },
            {
              name: '探索分析数据集',
              url: '/docs/ai-analytics/zh_CN/2.3.0/dataset_management/exploring_dataset.html'
            }
          ]
        },
        {
          name: '智能实验室',
          description: '集成主流的 Jupyter Lab 和 MLflow 作为模型开发环境，支持多样化格式打包机器学习模型，赋能模型的可视化对比与选优、实例的按需申请与协作共享，缩短复杂模型的训练周期。',
          image: 'assets/images/eap/MI_Lab.png',
          list: [
            {
              name: '智能实验室概述',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_lab/mi_lab_overview.html'
            },
            {
              name: '管理 Notebook 实例',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_lab/managing_notebook.html'
            },
            {
              name: '管理模型代码',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_lab/integrating_with_git.html'
            },
            {
              name: '跟踪 Notebook 运行实例',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_lab/integrating_with_mlflow.html'
            }
          ]
        },
        {
          name: '智能集市',
          description: '作为 AI 资产的集散中心，为模型开发者提供全面 AI 资产注册、托管与版本管理服务，并支持云边部署实例，高效管理 AI 资产，全面提升模型工程化效率。',
          image: 'assets/images/eap/MI_Hub.png',
          list: [
            {
              name: '智能集市概述',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_hub/mi_hub_overview.html'
            },
            {
              name: '注册和上架模型',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_hub/registering_model.html'
            },
            {
              name: '部署和调用模型服务',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_hub/version_deployment.html'
            },
            {
              name: '监控模型生产指标',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_hub/monitoring_indicator.html'
            }
          ]
        },
        {
          name: '智能任务流',
          description: '通过编排任务流实现机器学习算法模型的自动化上线部署及运行监控等端到端的生命周期管理，可灵活根据业务逻辑编排各类机器学习的任务节点，实现机器学习全链路闭环与持续的集成和部署。',
          image: 'assets/images/eap/MI_Pipelines.png',
          list: [
            {
              name: '智能任务流概述',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_pipelines/mi_pipeline_overview.html'
            },
            {
              name: '实验管理',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_pipelines/creating_workflow.html'
            },
            {
              name: '设计和管理任务流',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_pipelines/developing_model.html'
            },
            {
              name: '算子参考文档',
              url: '/docs/ai-analytics/zh_CN/2.3.0/mi_pipelines/calculator.html'
            }
          ]
        },
        {
          name: '资源配置',
          description: '提供统一的计算资源、存储资源配置和数据源连接管理功能，为企业分析平台中的智能实验室、智能集市、智能任务流等服务提供基础的连接及资源配备，帮助快速按需配置资源以开展机器学习相关工作。',
          image: 'assets/images/eap/Resource_Configuration.png',
          list: [
            {
              name: '资源配置概述',
              url: '/docs/ai-analytics/zh_CN/2.3.0/resource_configuration/resource_configuration_overview.html'
            },
            {
              name: '管理动态存储',
              url: '/docs/ai-analytics/zh_CN/2.3.0/resource_configuration/managing_storage.html'
            },
            {
              name: '配置数据源连接',
              url: '/docs/ai-analytics/zh_CN/2.3.0/resource_configuration/configuring_connection.html'
            }
          ]
        }
      ]
    },

    {
      category: '应用使能平台',
      image: 'assets/images/Application_Enablement_Platform_LIght.png',
      description: '提供应用开发所需的工具组件、函数库、和服务，帮助你快速构建、部署、和扩展应用。',
      url: '/docs/app-development/zh_CN/2.3.0/app_dev_overview.html',
      item: [
        {
          name: '应用开发基础',
          description: '基于 EnOS 提供的应用开发服务和组件，快速开始应用设计、开发、部署、和托管。',
          image: 'assets/images/aep/Application_Development_Basics.png',
          list: [
            {
              name: '注册和管理应用',
              url: '/docs/app-development/zh_CN/2.3.0/app_management/managing_apps.html'
            },
            {
              name: '使用 EnOS SDK 开发应用',
              url: '/docs/app-development/zh_CN/2.3.0/sdk_overview.html'
            },
            {
              name: '开发和发布 API',
              url: '/docs/apim/zh_CN/2.3.0/api_management_overview.html'
            }
          ]
        },
        {
          name: 'Application Portal',
          description: '与 EnOS 的服务及数据天然集成，通过应用程序用户身份和访问权限的集中管理及一致的网页和移动端响应式应用框架，帮助降低应用开发成本，实现跨应用的一体化体验。',
          image: 'assets/images/aep/Application_Portal.png',
          list: [
            {
              name: '有关 Application Portal',
              url: '/docs/app-portal/zh_CN/2.3.0/overview.html'
            },
            {
              name: '关键概念',
              url: '/docs/app-portal/zh_CN/2.3.0/concept.html'
            },
            {
              name: '快速入门',
              url: '/docs/app-portal/zh_CN/2.3.0/start/setting_up_app_portal.html'
            },
            {
              name: 'Application Portal API',
              url: '/docs/app-portal-api/zh_CN/2.3.0/overview.html'
            }
          ]
        },
        {
          name: '数据可视化',
          description: '内置丰富的图形组件，以简洁和无代码低代码的开发体验帮助开发者快速构建可视化应用，结合2D和3D技术，增强监控和运营应用的用户体验。',
          image: 'assets/images/aep/Digital_Twin_Visualization.png',
          list: [
            {
              name: '有关数据可视化服务',
              url: '/docs/dtv/zh_CN/2.3.0/overview.html'
            },
            {
              name: '创建项目与页面',
              url: '/docs/dtv/zh_CN/2.3.0/building_dashboard/creating_projects_pages.html'
            },
            {
              name: '组件参考文档',
              url: '/docs/dtv/zh_CN/2.3.0/reference/widgets/index.html'
            }
          ]
        },
        {
          name: '业务流程管理',
          description: '具备灵活编排能力和跨系统集成能力，提供低代码可视化的流程设计和生命周期管理，支持快速集成应用程序，加速业务流程数字化。',
          image: 'assets/images/aep/Business_Process_Management.png',
          list: [
            {
              name: '有关业务流程管理',
              url: '/docs/bpm/zh_CN/2.3.0/overview.html'
            },
            {
              name: '构建流程模型',
              url: '/docs/bpm/zh_CN/2.3.0/process_owner/building_process_models.html'
            },
            {
              name: '流程元素',
              url: '/docs/bpm/zh_CN/2.3.0/reference/process/index.html'
            },
            {
              name: '表单元素',
              url: '/docs/bpm/zh_CN/2.3.0/reference/form/index.html'
            }
          ]
        },
        {
          name: '通知管理（预览）',
          description: '为 EnOS 服务和基于 EnOS 开发的应用提供短信、邮件等推送服务，进行统一推送管理，保障推送高触达及安全性，并提供配额及计量管理，优化资源分配。',
          image: 'assets/images/aep/Notification_Management.png',
          list: [
            {
              name: '通知管理概述',
              url: '/docs/notification-mgmt/zh_CN/2.3.0/notification_center_overview.html'
            },
            {
              name: '基本概念',
              url: '/docs/notification-mgmt/zh_CN/2.3.0/notification_center_concepts.html'
            },
            {
              name: '快速入门：初始部署和配置消息推送服务',
              url: '/docs/notification-mgmt/zh_CN/2.3.0/notification_gettingstarted.html'
            }
          ]
        },
        {
          name: 'API 管理',
          description: '提供安全的 API 全生命周期管理，帮助企业快速通过 API 实现业务增长和开放集成。',
          image: 'assets/images/aep/API_Management.png',
          list: [
            {
              name: 'API 管理概述',
              url: '/docs/apim/zh_CN/2.3.0/api_management_overview.html'
            },
            {
              name: 'API 生命周期管理',
              url: '/docs/apim/zh_CN/2.3.0/api_lifecycle_management.html'
            },
            {
              name: 'API 管理安全机制',
              url: '/docs/apim/zh_CN/2.3.0/apim_security.html'
            },
            {
              name: '入门指引',
              url: '/docs/apim/zh_CN/2.3.0/learn/api_management_quickstart.html'
            }
          ]
        },
        {
          name: '开发者工作室',
          description: '基于 DevOps 最佳实践和最佳工具组合简化应用的开发、部署、运维和扩展，赋能应用开发人员和运营人员高效无缝协作，实现敏捷的业务创新。',
          image: 'assets/images/aep/Developer_Studio.png',
          list: [
            {
              name: '管理组织和应用开发项目',
              url: '/docs/ecp/zh_CN/2.3.0/howto/developerstudio/ou_project_app/ou_project_app.html'
            },
            {
              name: '管理流水线',
              url: '/docs/ecp/zh_CN/2.3.0/howto/devops/pipeline/creating_pipeline.html'
            },
            {
              name: '发布应用',
              url: '/docs/ecp/zh_CN/2.3.0/howto/devops/publishing_app/publishing_app.html'
            }
          ]
        },
        {
          name: '应用商店',
          description: '基于 Helm Chart 陈列通用和可复用组件或服务的集合，对该类服务以模板形式进行快速部署，简化业务应用的开发。',
          image: 'assets/images/aep/Application_Hosting.png',
          list: [
            {
              name: '管理应用模板',
              url: '/docs/ecp/zh_CN/2.3.0/howto/app_hub/managing_app_template.html'
            },
            {
              name: '部署应用实例',
              url: '/docs/ecp/zh_CN/2.3.0/howto/app_hub/deploying_app_instance.html'
            }
          ]
        },
        {
          name: '函数服务',
          description: '提供事件驱动的函数计算服务，以弹性、可靠的方式运行函数代码，实现函数级资源分配和调度。',
          image: 'assets/images/aep/Serverless.png',
          list: [
            {
              name: '函数服务概述',
              url: '/docs/ecp/zh_CN/2.3.0/howto/serverless/serverless_overview.html'
            },
            {
              name: '发布函数类型应用',
              url: '/docs/ecp/zh_CN/2.3.0/howto/serverless/managing_function.html'
            }
          ]
        },
        {
          name: '单点登录服务',
          description: '基于主流的标准协议，实现 EnOS 平台与第三方应用的单点登录，解决同一公司跨业务应用间的身份认证问题。',
          image: 'assets/images/aep/Single_Sign-On_Service.png',
          list: [
            {
              name: '有关单点登录',
              url: '/docs/sso/zh_CN/2.3.0/sso_overview.html'
            },
            {
              name: '基本概念',
              url: '/docs/sso/zh_CN/2.3.0/sso_concept.html'
            }
          ]
        },
        {
          name: '组态工具',
          description: '提供丰富的工业领域图形组件，帮助快速构建资产数据可视化和工业监控应用。',
          image: 'assets/images/aep/EnOS_HMI.png',
          list: [
            {
              name: '有关 EnOS 组态工具',
              url: '/docs/app-development/zh_CN/2.3.0/hmi/hmi_overview.html'
            },
            {
              name: '开发部署数据监控页面',
              url: '/docs/app-development/zh_CN/2.3.0/hmi/deploying_graph.html'
            }
          ]
        }
      ]
    }
  ]
};
